var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _g, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessMessage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 151,
    viewBox: "0 0 218 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M218 143.413H0V143.544H218V143.413Z",
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M187.349 146.418H144.795V146.549H187.349V146.418Z",
    fill: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M146.365 148.901H126.004V149.032H146.365V148.901Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M196.156 150.426H187.785V150.557H196.156V150.426Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4843 148.989H55.1543V149.119H95.4843V148.989Z",
    fill: "#EBEBEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2736 148.989H42.5972V149.119H51.2736V148.989Z",
    fill: "#EBEBEB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5451 147.115H25.2007V147.246H39.5451V147.115Z",
    fill: "#EBEBEB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M103.332 123.985H19.1405C17.7889 123.985 16.6553 122.852 16.6553 121.502V3.27857C16.6553 1.92819 17.7889 0.795616 19.1405 0.795616H103.332C104.684 0.795616 105.817 1.92819 105.817 3.27857V121.502C105.817 122.896 104.727 123.985 103.332 123.985ZM19.1405 0.926298C17.8325 0.926298 16.7425 1.97175 16.7425 3.32213V121.545C16.7425 122.852 17.7889 123.941 19.1405 123.941H103.332C104.64 123.941 105.73 122.896 105.73 121.545V3.27857C105.73 1.97175 104.684 0.882737 103.332 0.882737H19.1405V0.926298Z",
    fill: "#EBEBEB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M197.639 123.985H113.447C112.096 123.985 110.962 122.852 110.962 121.502V3.27857C110.962 1.92819 112.096 0.795616 113.447 0.795616H197.639C198.99 0.795616 200.124 1.92819 200.124 3.27857V121.502C200.124 122.896 199.034 123.985 197.639 123.985ZM113.447 0.926298C112.139 0.926298 111.049 1.97175 111.049 3.32213V121.545C111.049 122.852 112.096 123.941 113.447 123.941H197.639C198.947 123.941 200.037 122.896 200.037 121.545V3.27857C200.037 1.97175 198.99 0.882737 197.639 0.882737H113.447V0.926298Z",
    fill: "#EBEBEB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M170.52 139.405H38.8041L30.9561 50.1932H162.672L170.52 139.405Z",
    fill: "#F0F0F0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4935 142.28L38.8043 139.405L30.9563 50.1933L28.6455 53.0682L36.4935 142.28Z",
    fill: "#E0E0E0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5484 136.051L33.3108 53.8088C33.2236 52.9376 33.9212 52.197 34.7932 52.197H159.446C160.23 52.197 160.841 52.7633 160.928 53.5474L168.166 135.746C168.253 136.617 167.555 137.358 166.683 137.358H42.0308C41.2896 137.401 40.6356 136.792 40.5484 136.051Z",
    fill: "#FAFAFA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M57.334 139.405H37.496L36.1008 143.413H55.9388L57.334 139.405Z",
    fill: "#E0E0E0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3342 139.405H187.785L186.39 143.413H55.939L57.3342 139.405Z",
    fill: "#F5F5F5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M111.049 139.405H136.076L135.77 142.062H110.788L111.049 139.405Z",
    fill: "#E0E0E0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M148.938 44.3126H180.548C183.164 61.6497 171.043 75.894 153.734 75.894C148.196 75.894 142.528 74.4565 137.296 71.6686L148.938 44.3126Z",
    fill: "#E0E0E0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M148.938 44.3126L165.593 20.1365C169.56 23.0986 172.961 26.8012 175.577 30.983C178.15 35.1649 179.85 39.6952 180.548 44.3126H148.938Z",
    fill: "#EBEBEB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M148.937 44.3126L144.185 12.7312C147.891 12.7312 151.641 13.3846 155.259 14.6478C158.922 15.9111 162.41 17.7842 165.593 20.1365L148.937 44.3126Z",
    fill: "#E6E6E6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M148.938 44.3126L137.253 71.6686C126.658 66.0493 119.028 55.5948 117.328 44.3126C114.712 26.9755 126.833 12.7312 144.142 12.7312L148.938 44.3126Z",
    fill: "#F0F0F0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M109.959 100.636H137.994C138.343 103.076 138.43 105.515 138.125 107.867C137.863 110.22 137.253 112.485 136.337 114.619L109.959 100.636Z",
    fill: "#EBEBEB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M109.959 100.636L110.657 73.0625C117.328 74.1951 123.693 77.5928 128.707 82.6459C133.721 87.6989 136.991 94.0587 137.994 100.636H109.959Z",
    fill: "#E0E0E0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M109.959 100.636L85.0638 110.22C83.4942 107.17 82.4042 103.903 81.9246 100.636C79.6138 85.2595 90.3394 72.6269 105.73 72.6269C107.343 72.6269 109 72.7576 110.657 73.0625L109.959 100.636Z",
    fill: "#F0F0F0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M109.959 100.636L136.337 114.619C132.631 123.288 124.173 128.602 114.189 128.602C102.417 128.602 90.7753 121.197 85.0637 110.176L109.959 100.636Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M104.901 81.1212H65.6178C63.1326 81.1212 60.909 79.0739 60.7346 76.5909L58.7726 52.4584C58.5546 49.9754 60.4294 47.9281 62.9146 47.9281H102.198C104.683 47.9281 106.907 49.9754 107.081 52.4584L109.043 76.5909C109.261 79.1174 107.387 81.1212 104.901 81.1212Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M104.902 81.339H65.6181C63.0021 81.339 60.7349 79.2481 60.5169 76.6345L58.5549 52.5019C58.4677 51.2387 58.8601 50.0626 59.6885 49.1478C60.5169 48.233 61.6505 47.7538 62.9149 47.7538H102.198C104.814 47.7538 107.082 49.8447 107.3 52.4584L109.262 76.5909C109.349 77.8542 108.956 79.0303 108.128 79.9451C107.3 80.8163 106.166 81.339 104.902 81.339ZM62.9149 48.1459C61.7813 48.1459 60.7349 48.5815 59.9501 49.4091C59.2089 50.2368 58.8165 51.3258 58.9037 52.4584L60.8657 76.5909C61.0401 78.9868 63.1765 80.947 65.5745 80.947H104.858C105.992 80.947 107.038 80.5114 107.823 79.6837C108.564 78.8561 108.956 77.7671 108.869 76.6345L106.907 52.5019C106.733 50.1061 104.596 48.1459 102.198 48.1459H62.9149V48.1459Z",
    fill: "#407BFF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2195 74.108C92.6935 75.7633 90.6879 76.983 88.4643 77.5928L87.8103 75.7197C92.6499 74.4129 95.9199 69.8826 95.4839 64.5247C95.2223 61.3447 93.6963 58.4262 91.4291 56.3353L92.6935 54.9849C98.3615 60.2557 99.0591 68.8371 94.2195 74.108Z",
    fill: "#E0E0E0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6937 54.9849L91.4293 56.3353C89.1621 54.2444 86.1537 52.9375 82.9709 52.9375C79.7881 52.9375 76.9977 54.2444 75.0793 56.3353L73.5969 54.9849C75.9077 52.4584 79.2649 51.0209 82.8401 51.0209C86.3717 51.0644 89.9469 52.4584 92.6937 54.9849Z",
    fill: "#263238"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4645 77.5928C83.9301 78.8561 78.8289 77.5057 75.1229 74.108C69.4549 68.8807 68.7573 60.2557 73.5533 55.0285L75.0357 56.3788C73.1173 58.4697 72.0709 61.3447 72.3325 64.5682C72.8557 70.9716 78.4801 76.1553 84.8457 76.1553C85.8921 76.1553 86.8949 76.0246 87.8105 75.7633L88.4645 77.5928Z",
    fill: "url(#paint0_linear_14537_35360)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4046 8.94143H48.2654V9.33347H51.4046V8.94143Z",
    fill: "#407BFF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1697 8.94143H38.0193V9.33347H45.1697V8.94143Z",
    fill: "#407BFF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5238 43.6156H39.2838C36.7986 43.6156 34.575 41.5683 34.4006 39.0853L32.4386 14.9528C32.2206 12.4698 34.0954 10.4225 36.5806 10.4225H75.8642C78.3494 10.4225 80.573 12.4698 80.7474 14.9528L82.7094 39.0853C82.9274 41.6118 81.0526 43.6156 78.5238 43.6156Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5239 43.8334H39.2839C36.6679 43.8334 34.4007 41.7425 34.1827 39.1289L32.2207 14.9963C32.1335 13.7331 32.5259 12.557 33.3543 11.6422C34.1827 10.7274 35.3163 10.2482 36.5807 10.2482H75.8643C78.4803 10.2482 80.7475 12.3392 80.9655 14.9528L82.9275 39.0853C83.0147 40.3486 82.6223 41.5247 81.7939 42.4395C80.9655 43.3107 79.7883 43.8334 78.5239 43.8334ZM36.5807 10.6403C35.4471 10.6403 34.4007 11.0759 33.6159 11.9035C32.8747 12.7312 32.4823 13.8202 32.5695 14.9528L34.5315 39.0853C34.7059 41.4812 36.8423 43.4414 39.2403 43.4414H78.5239C79.6575 43.4414 80.7039 43.0058 81.4887 42.1781C82.2299 41.3505 82.6223 40.2615 82.5351 39.1289L80.5731 14.9963C80.3987 12.6005 78.2623 10.6403 75.8643 10.6403H36.5807Z",
    fill: "#407BFF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9705 17.3922H56.7677L56.5934 15.3013H35.7961L35.9705 17.3922Z",
    fill: "#E0E0E0"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5651 17.3922H56.7679L56.5935 15.3013H77.3907L77.5651 17.3922Z",
    fill: "#407BFF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4063 22.7066H42.3359L42.1615 20.6592H36.2319L36.4063 22.7066Z",
    fill: "#E0E0E0"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0011 22.7066H42.3363L42.1619 20.6592H77.8267L78.0011 22.7066Z",
    fill: "#407BFF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8426 28.0645H55.3726L55.1982 26.0172H36.6682L36.8426 28.0645Z",
    fill: "#E0E0E0"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M78.437 28.0645H55.3726L55.1982 26.0172H78.2626L78.437 28.0645Z",
    fill: "#407BFF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2786 33.4225H68.8886L68.7142 31.3751H37.1042L37.2786 33.4225Z",
    fill: "#E0E0E0"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8729 33.4225H68.8885L68.7141 31.3751H78.6985L78.8729 33.4225Z",
    fill: "#407BFF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7144 38.7804H52.3204L52.146 36.6895H37.54L37.7144 38.7804Z",
    fill: "#E0E0E0"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3088 38.7804H52.3204L52.146 36.6895H79.1344L79.3088 38.7804Z",
    fill: "#407BFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_14537_35360)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_14537_35360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.239 43.6156H92.9552C90.47 43.6156 88.2464 41.5683 88.072 39.0853L86.11 14.9528C85.892 12.4698 87.7668 10.4225 90.252 10.4225H129.536C132.021 10.4225 134.244 12.4698 134.419 14.9528L136.381 39.0853C136.599 41.6118 134.724 43.6156 132.239 43.6156Z",
    fill: "#407BFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M132.239 43.8334H92.9555C90.3395 43.8334 88.0723 41.7425 87.8543 39.1289L85.8923 14.9963C85.8051 13.7331 86.1975 12.557 87.0259 11.6422C87.8543 10.7274 88.9879 10.2482 90.2523 10.2482H129.536C132.152 10.2482 134.419 12.3392 134.637 14.9528L136.599 39.0853C136.686 40.3486 136.294 41.5247 135.466 42.4395C134.637 43.3107 133.504 43.8334 132.239 43.8334ZM90.2523 10.6403C89.1187 10.6403 88.0723 11.0759 87.2875 11.9035C86.5463 12.7312 86.1539 13.8202 86.2411 14.9528L88.2031 39.0853C88.3775 41.4812 90.5139 43.4414 92.9119 43.4414H132.196C133.329 43.4414 134.376 43.0058 135.16 42.1781C135.902 41.3505 136.294 40.2615 136.207 39.1289L134.245 14.9963C134.07 12.6005 131.934 10.6403 129.536 10.6403H90.2523Z",
    fill: "#407BFF"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2086 118.322H50.925C48.4397 118.322 46.2161 116.275 46.0417 113.792L44.0797 89.6591C43.8617 87.1762 45.7365 85.1288 48.2217 85.1288H87.5054C89.9906 85.1288 92.2142 87.1762 92.3886 89.6591L94.3506 113.792C94.5686 116.275 92.6938 118.322 90.2086 118.322Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2088 118.54H50.9252C48.3092 118.54 46.042 116.449 45.824 113.835L43.862 89.7027C43.7748 88.4394 44.1672 87.2633 44.9956 86.3485C45.824 85.4337 46.9576 84.9546 48.222 84.9546H87.5056C90.1216 84.9546 92.3888 87.0455 92.6068 89.6591L94.5688 113.792C94.656 115.055 94.2636 116.231 93.4352 117.146C92.6068 118.017 91.4732 118.54 90.2088 118.54ZM48.222 85.3466C47.0884 85.3466 46.042 85.7822 45.2572 86.6099C44.516 87.4375 44.1236 88.5265 44.2108 89.6591L46.1728 113.792C46.3472 116.188 48.4836 118.148 50.8816 118.148H90.1652C91.2988 118.148 92.3452 117.712 93.13 116.884C93.8712 116.057 94.2636 114.968 94.1764 113.835L92.2144 89.7027C92.04 87.3068 89.9036 85.3466 87.5056 85.3466H48.222Z",
    fill: "#407BFF"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5412 101.159L61.9996 110.917L71.7224 95.9754L77.6956 103.686L79.178 101.464L88.988 113.182H51.3176L53.5412 101.159Z",
    fill: "url(#paint1_linear_14537_35360)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7945 101.769L77.8705 110.176L65.3137 90.2689L59.4277 102.902L57.5093 99.9394L51.3181 113.182H88.9885L81.7945 101.769Z",
    fill: "#E0E0E0"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M106.891 39.3783C107.609 39.9964 108.672 39.9964 109.204 39.3783L124.853 21.2065C125.386 20.5885 125.228 19.5377 124.51 18.9196L121.927 16.6945C121.209 16.0764 120.209 16.0764 119.677 16.6945L106.902 31.5286L98.8009 24.606C98.0832 23.9879 97.0832 23.9879 96.5509 24.606L94.6346 26.8311C94.1023 27.4492 94.2599 28.5 94.9776 29.118L106.891 39.3783Z",
    fill: "url(#paint2_linear_14537_35360)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M108.483 38.5827C109.201 39.2007 110.263 39.2007 110.795 38.5827L126.445 20.4109C126.977 19.7928 126.819 18.7421 126.102 18.124L123.518 15.8989C122.8 15.2808 121.8 15.2808 121.268 15.8989L108.493 30.733L100.392 23.8104C99.6745 23.1923 98.6745 23.1923 98.1422 23.8104L96.2259 26.0355C95.6936 26.6536 95.8512 27.7043 96.5689 28.3224L108.483 38.5827Z",
    fill: "url(#paint3_linear_14537_35360)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M110.074 36.1958C110.792 36.8139 111.854 36.8139 112.387 36.1958L128.036 18.0241C128.568 17.406 128.411 16.3552 127.693 15.7371L125.109 13.512C124.392 12.8939 123.392 12.8939 122.859 13.512L110.084 28.3461L101.983 21.4235C101.266 20.8055 100.266 20.8055 99.7335 21.4235L97.8172 23.6486C97.2849 24.2667 97.4425 25.3175 98.1602 25.9356L110.074 36.1958Z",
    fill: "url(#paint4_linear_14537_35360)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M158.329 31.4586L159.983 33.4161L164.694 31.4586L163.357 29.438L158.329 31.4586Z",
    fill: "url(#paint5_linear_14537_35360)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9197 38.1898C50.9197 39.5088 49.8519 40.5766 48.5329 40.5766C47.2138 40.5766 46.146 39.5088 46.146 38.1898C46.146 36.8707 47.2138 35.8029 48.5329 35.8029C49.8519 35.8029 50.9197 36.8707 50.9197 38.1898Z",
    fill: "url(#paint6_linear_14537_35360)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6278 4.37591C67.6278 5.06684 67.0625 5.56934 66.4344 5.56934C65.7435 5.56934 65.241 5.00403 65.241 4.37591C65.241 3.68498 65.8063 3.18248 66.4344 3.18248C67.1253 3.18248 67.6278 3.74779 67.6278 4.37591Z",
    fill: "url(#paint7_linear_14537_35360)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M149.577 85.1314C149.577 85.5557 149.205 85.927 148.781 85.927C148.357 85.927 147.985 85.5557 147.985 85.1314C147.985 84.7071 148.357 84.3358 148.781 84.3358C149.205 84.3358 149.577 84.654 149.577 85.1314Z",
    fill: "url(#paint8_linear_14537_35360)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4817 69.9009L24.2166 70.0146L25.4598 65.2409L22.9735 65.3545L21.4817 69.9009Z",
    fill: "url(#paint9_linear_14537_35360)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M178.219 104.113L180.954 104.226L182.197 99.4525L179.711 99.5662L178.219 104.113Z",
    fill: "url(#paint10_linear_14537_35360)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M140.029 0.640828L140.926 3.26823L146.433 2.30698L145.28 0L140.029 0.640828Z",
    fill: "url(#paint11_linear_14537_35360)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8613 127.94L98.7579 130.567L104.265 129.606L103.112 127.299L97.8613 127.94Z",
    fill: "url(#paint12_linear_14537_35360)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0183 27.0511L11.1387 29.237L15.1764 33.4161L16.708 31.1658L13.0183 27.0511Z",
    fill: "url(#paint13_linear_14537_35360)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_14537_35360",
    x: 81.8804,
    y: 6.24825,
    width: 58.7305,
    height: 41.5852,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14537_35360"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14537_35360",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_14537_35360",
    x: 78.0928,
    y: 6.42248,
    width: 66.3052,
    height: 49.1931,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14537_35360"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14537_35360",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14537_35360",
    x1: 79.4164,
    y1: 55.0285,
    x2: 79.4164,
    y2: 78.0591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D9AF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0043A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14537_35360",
    x1: 70.1528,
    y1: 95.9754,
    x2: 70.1528,
    y2: 113.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D9AF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0043A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14537_35360",
    x1: 104.73,
    y1: 12.1825,
    x2: 104.73,
    y2: 37.3607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26FF62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992708,
    stopColor: "#01D0EC",
    stopOpacity: 0.27
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_14537_35360",
    x1: 106.321,
    y1: 11.3869,
    x2: 106.321,
    y2: 36.5651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26FF62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992708,
    stopColor: "#01D0EC",
    stopOpacity: 0.27
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_14537_35360",
    x1: 107.913,
    y1: 9,
    x2: 107.913,
    y2: 34.1782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26FF62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992708,
    stopColor: "#01D0EC",
    stopOpacity: 0.27
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_14537_35360",
    x1: 159.479,
    y1: 31.0212,
    x2: 162.554,
    y2: 35.0455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5015,
    stopColor: "#FCA22E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC7200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_14537_35360",
    x1: 48.5329,
    y1: 35.8029,
    x2: 48.5329,
    y2: 40.5766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E59EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A338E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_14537_35360",
    x1: 66.4344,
    y1: 3.18248,
    x2: 66.4344,
    y2: 5.56934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E59EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A338E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_14537_35360",
    x1: 148.781,
    y1: 84.3358,
    x2: 148.781,
    y2: 85.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E59EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A338E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_14537_35360",
    x1: 22.201,
    y1: 67.1408,
    x2: 25.7603,
    y2: 69.5676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5015,
    stopColor: "#FCA22E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC7200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_14537_35360",
    x1: 178.938,
    y1: 101.352,
    x2: 182.497,
    y2: 103.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5015,
    stopColor: "#FCA22E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC7200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_14537_35360",
    x1: 143.231,
    y1: 0,
    x2: 143.231,
    y2: 3.26823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E59EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A338E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_14537_35360",
    x1: 101.063,
    y1: 127.299,
    x2: 101.063,
    y2: 130.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E59EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A338E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_14537_35360",
    x1: 12.1456,
    y1: 29.5843,
    x2: 16.9717,
    y2: 33.0393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5015,
    stopColor: "#FCA22E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC7200"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessMessage);
export default __webpack_public_path__ + "static/media/success_message.55c7c5a873afa6cbf642b26f43b40c22.svg";
export { ForwardRef as ReactComponent };